import { createFileRoute } from "@tanstack/react-router";
import { EligibilityDetail } from "@/components/EligibilityDetail";

export const Route = createFileRoute("/eligibility/elite")({
  component: () => <EligibilityDetail slug="elite" />,
});
